import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Err4XXPopupComponent } from '@shared/popups/error-popups/err4xx/errors4xx-popup.component';
import { Err5XXPopupComponent } from '@shared/popups/error-popups/err5xx/errors5xx-popup.component';

@Injectable({
  providedIn: 'root',
})
export class ErrorsService {
  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _dialog: MatDialog,
  ) {}

  noResult(): void {}

  openPopup(err: HttpErrorResponse, option?: string) {
    console.log(err, option);

    let status = err.status;
    if (status < 500) {
      let message;
      Object.values(err.error).forEach((msg) => {
        message = msg;
      });

      const dialogRef = this._dialog.open(Err4XXPopupComponent, {
        data: {
          message,
          status: err.status,
        },
      });
      if (option) {
        dialogRef.afterClosed().subscribe((isDelete: boolean) => {
          this._router.navigateByUrl(option);
        });
      }
    }
    if (status >= 500) {
      const dialogRef = this._dialog.open(Err5XXPopupComponent, {});
      dialogRef.afterClosed().subscribe((isDelete: boolean) => {});
    }
  }

  criticalErr(): void {
    this._router.navigateByUrl(`crytical`);
  }
}
